import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CapitalizePipe } from '../../../core/pipes/capitalize.pipe';
import { filter as filterOp, delay } from 'rxjs';
import { FilterItem } from '../../../core/models/filters.models';
import { CenterModel, GenericModel } from '../../../core/models/honorary';
import { PlatformServices } from '../../../core/services/platform/platform.service';
import { MatIconModule } from '@angular/material/icon';
import {MatAccordion, MatExpansionModule, MatExpansionPanel} from '@angular/material/expansion';
import { StatisticsService } from '../../../core/services/statistics/statistics.service';
import { YearsSelected } from '../../../core/models/statistics.model';

@Component({
  selector: 'app-statistics-configurations-dialog',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslateModule, MatCheckboxModule,
    FormsModule, ReactiveFormsModule, CapitalizePipe, MatFormFieldModule, MatInputModule,
    MatCardModule, MatDatepickerModule, MatNativeDateModule, MatButtonModule, MatTooltipModule,
    MatExpansionModule, MatIconModule, MatFormFieldModule],
  templateUrl: './statistics-configurations-dialog.component.html',
  styleUrl: './statistics-configurations-dialog.component.scss'
})
export class StatisticsConfigurationsDialogComponent {
  @ViewChild('panelFee', { read: MatExpansionPanel, static: false}) panelFee!: MatExpansionPanel;
  @ViewChild('panelSummary', { read: MatExpansionPanel, static: false}) panelSummary!: MatExpansionPanel;

  private readonly defaultYearsValues = [new Date().getFullYear().toString(), (new Date().getFullYear() - 1).toString()];
  readonly currentYear = new Date().getFullYear();

  annualFeeYearsCurrentIndex = 1;
  annualSummaryYearsCurrentIndex = 1;

  showSearch = false;

  panelSearchControl = new FormControl();
  panelFeeOpen: boolean = false;
  panelSummaryOpen: boolean = false;

  currentSearchPanel = '';
  currentScreen = '';
  lastPanelFilter = true;

  annualFeeYears: string[] = [];
  filteredAnnualFeeYears: string[] = [];
  searchAnnualFeeYears: string[] = [];

  annualSummaryYears: string[] = [];
  filteredAnnualSummaryYears: string[] = [];
  searchAnnualSummaryYears: string[] = [];
  lastSummaryYearsSelected: string[] = [];

  initialSummaryYearsSelected: string[] = [];
  initialFeeYearsSelected: string[] = [];

  hasChange: boolean = false;

  constructor(
    private translate: TranslateService,
    private plataform: PlatformServices,
    public dialogRef: MatDialogRef<StatisticsConfigurationsDialogComponent>,
    public dialog: MatDialog,
    private statisticsService: StatisticsService
  ) {
    this.currentScreen = plataform.currentScreenSize;

    for (let i = 0; i < 50; i++) {
      this.annualFeeYears.push((this.currentYear - i).toString());
      this.annualSummaryYears.push((this.currentYear - i).toString());
    }
  }

  ngAfterViewInit() {
    this.panelFee.expandedChange.subscribe((isExpanded: boolean) => {
      isExpanded ? this.panelFeeOpen = true : this.panelFeeOpen = false;
    });
    this.panelSummary.expandedChange.subscribe((isExpanded: boolean) => {
      isExpanded ? this.panelSummaryOpen = true : this.panelSummaryOpen = false;
    });
  }

  filters: FilterItem[] = [
    {
      label: '',
      id: 'annualFeeYears',
      open: false,
      viewMore: false,
    },
    {
      label: '',
      id: 'annualSummaryYears',
      open: false,
      viewMore: false,
    }

  ]

  formControl = new FormGroup({
    annualFeeYears: new FormControl<string[]>([], [Validators.minLength(1), Validators.maxLength(1)]),
    annualSummaryYears: new FormControl<string[]>([], [Validators.minLength(2), Validators.maxLength(2)])
  })

  ngOnInit() {
    this.formControl.updateValueAndValidity();

    if(this.statisticsService.getAnnualFeeYears().length) {
      const years = this.statisticsService.getAnnualFeeYears() as string[];
      this.initialFeeYearsSelected = years;
      this.formControl.get("annualFeeYears")?.setValue(years);

    } else {
      this.initialFeeYearsSelected = [this.defaultYearsValues[0]];

      this.formControl.get("annualFeeYears")?.setValue([this.defaultYearsValues[0]]);
    }

    if(this.statisticsService.getAnnualSummaryYears().length) {
      const years = this.statisticsService.getAnnualSummaryYears() as string[];
      this.initialSummaryYearsSelected = [...years];
      this.lastSummaryYearsSelected = years;

      this.formControl.get("annualSummaryYears")?.setValue(years);

    } else {
      this.initialSummaryYearsSelected = [...this.defaultYearsValues];
      this.lastSummaryYearsSelected = [...this.defaultYearsValues];

      this.formControl.get("annualSummaryYears")?.setValue([...this.defaultYearsValues]);

    }
  }

  
  openFilter(filter: FilterItem) {
    filter.open = !filter.open;
  }

  updateChkbxArray(event: MatCheckboxChange, id: string, key: string) {
    const isChecked = event.checked;
    const formControl = this.formControl.get(key);
    
    switch(key) {
      case 'annualFeeYears' : {
        formControl?.setValue([id]);
        // this.sortAnualFeeYears();
        break;
      }
      case 'annualSummaryYears': {
        if (isChecked) {
          if(this.lastSummaryYearsSelected.length > 2 ) {
            this.lastSummaryYearsSelected.splice(2);
          } else if(this.lastSummaryYearsSelected.length === 2) {
            this.lastSummaryYearsSelected.push(id);
            this.lastSummaryYearsSelected.splice(0,1);
          } else {
            this.lastSummaryYearsSelected.push(id);
          }


        } else {
          this.lastSummaryYearsSelected = this.lastSummaryYearsSelected.filter(
            year => year !== id
          );
        }
        
        formControl?.setValue(this.lastSummaryYearsSelected);
        break;
      }
    }

    this.hasChange = !this.compareArrays(key);

  }

  sortAnualFeeYears() {
    const selected = this.annualFeeYears.filter(feeYear =>
      (this.formControl.get('annualFeeYears')?.value || [] as string[]).includes(feeYear)
    ).sort((a, b) => a < b ? 1 : -1);
    const noSelected = this.annualFeeYears.filter(feeYear => !
      (this.formControl.get('annualFeeYears')?.value || [] as string[]).includes(feeYear)
    ).sort((a, b) => a < b ? 1 : -1);
    this.annualFeeYears = [...selected, ...noSelected];

  }

  sortAnualSummaryYears() {
    const selected = this.annualSummaryYears.filter(summaryYear =>
      (this.formControl.get('annualSummaryYears')?.value || [] as string[]).includes(summaryYear)
    ).sort((a, b) => a < b ? 1 : -1);
    const noSelected = this.annualSummaryYears.filter(summaryYear => !
      (this.formControl.get('annualSummaryYears')?.value || [] as string[]).includes(summaryYear)
    ).sort((a, b) => a < b ? 1 : -1);
    this.annualSummaryYears = [...selected, ...noSelected];

  }

  viewMore(filter: string) {
    if (filter === 'annualFeeYears') {
      this.annualFeeYearsCurrentIndex++;
      return;
    }
    if (filter === 'annualSummaryYears') {
      this.annualSummaryYearsCurrentIndex++;
      return
    }
    const filterItemSelected: any = this.filters.find(filterItem => filterItem.id === filter);
    filterItemSelected.viewMore = !filterItemSelected.viewMore;
  }

  viewLess(filter: string) {
    if (filter === 'annualFeeYears' && this.annualFeeYears.length > 6) {
      this.annualFeeYearsCurrentIndex = 1;
      return
    }
    if (filter === 'annualSummaryYears' && this.annualSummaryYears.length > 6) {
      this.annualSummaryYearsCurrentIndex = 1;
      return
    }
    const filterItemSelected: any = this.filters.find(filterItem => filterItem.id === filter);
    filterItemSelected.viewMore = !filterItemSelected.viewMore;
  }

  search(filter: string) {
    this.showSearch = true;
    this.currentSearchPanel = filter;
    this.panelSearchControl.reset();

    if (filter === 'annualFeeYears') {
      this.filteredAnnualFeeYears = [...this.annualFeeYears];


      this.searchAnnualFeeYears = this.filteredAnnualFeeYears.slice(0,6);

      this.panelSearchControl.valueChanges
        .pipe(
          delay(300),
        )
        .subscribe(value => {
          if(value.length >= 2) {
            this.searchAnnualFeeYears = this.filteredAnnualFeeYears.filter(c => c.toLowerCase().indexOf(value.toLowerCase()) >= 0);
            if (this.searchAnnualFeeYears.length < 1) {
              this.panelSearchControl.setErrors({ notFound: "remuneration-page.messages.record-not-found" })
            }
          } else {
            this.searchAnnualFeeYears = this.annualFeeYears.slice(0,6);
          }


        })

    } else if(filter === 'annualSummaryYears') {
      this.filteredAnnualSummaryYears = [...this.annualSummaryYears];


      this.searchAnnualSummaryYears = this.filteredAnnualSummaryYears.slice(0,6);

      this.panelSearchControl.valueChanges
        .pipe(
          delay(300),
        )
        .subscribe(value => {
          if(value.length >= 2) {
            this.searchAnnualSummaryYears = this.filteredAnnualSummaryYears.filter(c => c.toLowerCase().indexOf(value.toLowerCase()) >= 0);
            if (this.searchAnnualFeeYears.length < 1) {
              this.panelSearchControl.setErrors({ notFound: "remuneration-page.messages.record-not-found" })
            }
          } else {
            this.searchAnnualSummaryYears = this.annualSummaryYears.slice(0,6);
          }


        })
    }

  }
  

  applySearch() {
    this.showSearch = false;
  }

  clearInputSearch() {
    this.panelSearchControl.setValue("");
    this.searchAnnualFeeYears = this.annualFeeYears.slice(0, 6);
    this.searchAnnualSummaryYears = this.annualSummaryYears.slice(0, 6);
  }

  submit() {
    const yearsSelected: YearsSelected = {
      annualFeeYears: this.formControl.get('annualFeeYears')?.value as string[],
      annualSummaryYears: this.formControl.get('annualSummaryYears')?.value as string[]
    }
    this.statisticsService.getStatistics(yearsSelected);
    
    this.close();
  }


  getName(inputName: string): string {
    switch (inputName) {
      case 'annualFeeYears': {
        return this.annualFeeYears.filter((annualFee: string) => {
          if (this.formControl.get('annualFeeYears')?.value) {
            const resp = (this.formControl.get('annualFeeYears')?.value || [] as Array<string>).some(v => v === annualFee);
            return resp;
          }
          return false;
        }).map((c, i) => i === 0 ? c : ' ' + c).join()

      }
      case 'annualSummaryYears': {
        return this.annualSummaryYears.filter((annualSummary: string) => {
          if (this.formControl.get('annualSummaryYears')?.value) {
            const resp = (this.formControl.get('annualSummaryYears')?.value || [] as Array<string>).some(v => v === annualSummary);
            return resp;
          }
          return false;
        }).map((c, i) => i === 0 ? c : ' ' + c).join()

      }
      default: {
        return this.formControl.get(inputName)?.value
      }
    }

  }

  isChecked(feeYearId: string, controlName: string): boolean {
    const formControl = this.formControl.get(controlName)?.value;
    return formControl.includes(feeYearId);
  }
  
  isFormEmpty(): boolean {
    const formValues = this.formControl.value;
    return !Object.values(formValues).some(value => {
      if (Array.isArray(value)) {
        return value.length !== 0;
      }
      return value !== null && value !== undefined;
    });
  }

  compareArrays(key: string): boolean {
    const formValuesSelected = this.formControl.get(key)?.value as string[];
    let initialYearsSelected: string[] = [];

    switch(key) {
      case "annualFeeYears": {
        initialYearsSelected = this.initialFeeYearsSelected;
        break;
      }
      case "annualSummaryYears": {
        initialYearsSelected = this.initialSummaryYearsSelected;
        break;
      }
    }

    return this.arraysAreEqual(formValuesSelected, initialYearsSelected);
  }
  
  arraysAreEqual(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    return arr1.every((value, index) => value === arr2[index]);
  }

  close() {
    this.dialogRef.close();
  }
}



